import styled from 'styled-components'

export default styled.p`
    margin: 0 0 0 10px;
    flex-shrink:1;
    font-family: "Poppins"
`